// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2_bPq","content":"LoadingAlert_content__1tHgx"};